import { useEffect, useState } from 'react'
import useDebounce from '../hooks/useDebounce'

const API = process.env.REACT_APP_API_URL

function MenuManagement() {
  const [search, setSearch] = useState('')
  const debouncedSearch = useDebounce(search)
  const [items, setItems] = useState([])

  useEffect(() => {
    const fetchMenu = async () => {
      const url = debouncedSearch
        ? `${API}/menu/search?q=${debouncedSearch}`
        : `${API}/menu`
      const res = await fetch(url)
      setItems(await res.json())
    }
    fetchMenu()
  }, [debouncedSearch])

  return (
    <div>
      <input
        placeholder="Search menu"
        value={search}
        onChange={e => setSearch(e.target.value)}
      />

      {items.map(item => (
        <div key={item._id}>
          {item.name} – {item.isAvailable ? 'Available' : 'Unavailable'}
        </div>
      ))}
    </div>
  )
}

export default MenuManagement
